import {Module} from "module/Module";
import {StTagReducerNS} from 'module/StTag/reducer/StTagReducer'
import {StTagEpic} from 'module/StTag/epic/StTagEpic'

export const StTagModule: Module = {
	epics: [StTagEpic],
	reducerNS: StTagReducerNS,
}